<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="6" :lg="6" :md="6" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.carNo" placeholder="请输入车辆编号" clearable></Input>
        </Col>
        <Col span="6" :lg="6" :md="6" :sm="12" :xs="24" class="margin-bottom">
        <Select v-model="params.gfType" clearable placeholder="请选择围栏类型">
          <Option v-for="(item,index) in gfTypeData" :value="item.value" :key="'a'+index">{{ item.label }}</Option>
        </Select>
        </Col>
        <Col span="6" :lg="6" :md="6" :sm="12" :xs="24" class="margin-bottom">
        <Select v-model="params.alarmType" clearable placeholder="请选择预警类型">
          <Option v-for="(item,index) in alarmTypeData" :value="item.value" :key="'a'+index">{{ item.label }}</Option>
        </Select>
        </Col>
        <Col span="6" :lg="6" :md="6" :sm="12" :xs="24" class="margin-bottom">
        <DatePicker style="width: 100%;" v-model="params.alarmTime" @on-change="DatePickerChange" type="date" format="yyyy-MM-dd" placeholder="请选择警报时间"></DatePicker>
        </Col>
        <Col span="24" :lg="24" :md="24" :sm="24" :xs="24" class="page-action">
        <div>
          <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
          <Button icon="ios-reset" @click="reset()">清空</Button>
        </div>
        <div></div>
        </Col>
      </Row>
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
    </div>
    <alarmMap ref="alarmMap"></alarmMap>
  </sl-page>
</template>
<script>
import alarmMap from './alarmMap'
import dics from './dics'

export default {
  components: { alarmMap },
  data() {
    return {
      ...dics,
      columns: [{
          type: 'index',
          width: 65,
          title: '序号',
          align: 'center'
        },
        {
          title: '围栏名称',
          key: 'gfName',
          minWidth: 150,
        },
        {
          title: '车辆编号',
          key: 'carNo',
          minWidth: 150,
        },
        {
          title: '围栏类型',
          minWidth: 150,
          render: (h, params) => {
            let gfType = params.row.gfType
            let txt = ''
            dics.gfTypeData.forEach(item => {
              if (String(item.value) === String(gfType)) {
                txt = item.label
              }
            })
            let H = ''
            let color = 'cyan'
            if (gfType === 0) {
              color = 'red'
            } else if (gfType === 2) {
              color = 'green'
            } else if (gfType === 3) {
              color = 'gold'
            }
            H = h('Tag', {
              props: { color: color },
              style: { textAlign: 'center', cursor: 'auto' },
            }, txt)
            return H
          }
        },
        {
          title: '报警类型',
          minWidth: 150,
          render: (h, params) => {
            let alarmType = params.row.alarmType
            let txt = ''
            dics.alarmTypeData.forEach(item => {
              if (String(item.value) === String(alarmType)) {
                txt = item.label
              }
            })
            return h('div', txt)
          }
        },
        {
          title: '所属企业',
          key: 'companyName',
          minWidth: 150,
        },
        {
          title: '当前快递员',
          key: 'driverName',
          minWidth: 150,
        },
        {
          title: '快递员电话',
          key: 'driverPhone',
          minWidth: 150,
        },
        {
          title: '时间',
          minWidth: 160,
          render: (h, params) => {
            let txt = params.row.alarmTime ? this.$utils.datetime(params.row.alarmTime) : ''
            return h('div', txt)
          }
        },
        {
          title: '地点',
          key: 'alarmAddrDetail',
          minWidth: 150,
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let acts = []
            let detailH = h('a', {
              props: {
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              directives: [
                {
                  name: 'permission',
                  value: 'setting.alarm.map',
                }
              ],
              on: {
                click: () => {
                  this.showAlarmMap(params.row.id)
                }
              }
            }, '查看地图')
            acts = [detailH]
            return h('div', acts)
          }
        }
      ],
      data: [],
      params: {
        carNo: null,
        gfType: null,
        alarmType: null,
        alarmTime: null,
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      selection: []
    }
  },
  computed: {
    removeDisable() {
      return this.selection.length == 0
    }
  },
  created() {
    this.def = { ...this.params }
    this.list()
  },

  methods: {

    list() {
      // 搜索值过滤
      let search = this.$utils.filterSearch(this.params)

      let params = { search: search, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.fenceAlarmMsgQueryPage(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = resp.data.list || []
          this.page.total = resp.data.total || 0
        }
      })
    },

    edit({ row }) {
      this.$refs['item'].init(row.id)
    },

    create() {
      this.$refs['item'].init(0)
    },

    reset() {
      this.$utils.fill(this.params, this.def)
      this.list()
    },

    handleUpdate() {
      this.modalVisible = false
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    },

    DatePickerChange(str) {
      console.log('DatePickerChange----', str)
      this.params.alarmTime = str
    },

    showAlarmMap(id) {
      this.$refs.alarmMap.init(id)
    }
  }
}

</script>
